module.exports = __webpack_public_path__ + "static/img/box2-img.d439ed44.jpg";